import type { FretPosition } from "./types";

/** Cuerdas objetivo del paso (p. ej. vibrar la cuerda al aire pedida). */
export function targetStringsFromPositions(positions?: FretPosition[]): number[] {
  if (!positions?.length) return [];
  return [...new Set(positions.map((p) => p.string))].sort((a, b) => a - b);
}
